import React, { useState } from "react";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useSelector } from "react-redux";
import GradientButton from "../../common/GradiantButton";
import SecondaryButton from "../../common/SecondaryButton";
import { investorApi } from "../../../api/api";

const Withdraw = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const theme = useSelector((data) => data.themeValue.colors);
  const { walletAmount, userId } = location.state || {};
  const themeMode = useSelector((data) => data.themeValue.theme);
  const validateAmount = () => {
    if (!amount) {
      setError("Please enter an amount");
      return false;
    }
    if (isNaN(amount) || parseFloat(amount) <= 0) {
      setError("Please enter a valid positive number");
      return false;
    }
    if (parseFloat(amount) > walletAmount) {
      setError("Amount exceeds wallet balance");
      return false;
    }
    return true;
  };
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("amount", amount);
  const handleWithdraw = async () => {
    if (!validateAmount()) return;
    const response = await investorApi.addWithdraw(formData);
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      navigate("/wallet", {
        state: { successMessage: `Withdrawn $${parseFloat(amount).toFixed(2)} successfully.` },
      });
    }, 1200);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 3,
          bgcolor: themeMode === "light" ? "background.paper" : "grey.900",
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600, color: theme.text }}>
          Withdraw Funds
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: theme.text }}>
          Available Balance: ₹ {walletAmount.toLocaleString()}
        </Typography>

        <TextField
          fullWidth
          label="Withdrawal Amount"
          variant="outlined"
          value={amount}
         
          onChange={(e) => {
            const value = e.target.value;
            setAmount(value);

            // Clear error first
            let errorMessage = "";

            if (!value) {
              errorMessage = "Please enter an amount";
            } else if (isNaN(value) || parseInt(value) <= 0) {
              errorMessage = "Please enter a valid positive number";
            } else if (parseInt(value) > walletAmount) {
              errorMessage = "Amount exceeds wallet balance";
            }

            setError(errorMessage);
          }}
          error={!!error}
          helperText={error}
          type="number"
          InputProps={{
            // startAdornment: (
            //   <InputAdornment position="start">
            //     <AttachMoneyIcon sx={{color:theme.normal_icon}} />
            //   </InputAdornment>
            // ),
            inputProps: { min: 0, max: walletAmount, step: "0.01" },
          }}
          sx={{
            mb: 3,
            ...(error && {
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'red',
                },
              },
            }),
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
          }}
        />
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ display: "flex", gap: 2 }}>

          <GradientButton
            width="50%"
            onClick={handleWithdraw}
            disabled={submitting || !amount}
            text={submitting ? <CircularProgress size={24} color="inherit" /> : "Withdraw"}
          />
          <SecondaryButton
            text="Cancel"
            onClick={() => navigate("/wallet")}
            width="50%"

          />
        </Box>
      </Paper>
    </Container>
  );
};

export default Withdraw;